var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container bg-white",staticStyle:{"padding":"20px 0 0 30px"}},[_c('time-select',{on:{"timeChange":_vm.timeChange}}),_c('statistical-chart',{ref:"statisticalChart",on:{"paramsChange":_vm.paramsChange,"exportData":_vm.exportData}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }